import React, { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';
import axios from 'axios';

export default function LoginForm() {
  const [form, setForm] = useState({
    username: '', password: '', loginas: 'Student', academic_year: '', regi_id: ''
  });
  const [years, setYears] = useState([]);
  const [studentOptions, setStudentOptions] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const togglePassword = () => {
    setShowPassword(prev => !prev);
  };
  useEffect(() => {
    axios.get('/api/common/academic-years')
      .then(res => setYears(res.data))
      .catch(err => {
        console.error(err);
        setError('Failed to load academic years.');
      });
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      const { data } = await axios.post('/api/auth/login', form);
      if (data.status === 'choose') {
        setStudentOptions(data.options);
        setMessage('Multiple student accounts found. Please select one.');
      } else if (data.status === 'ok') {
        setMessage('Login successful. Redirecting...');
        window.location = form.loginas === 'Student' ? '/student/dashboard' : '/admin/dashboard';
      } else {
        setError(data.message || 'Login failed.');
      }
    } catch (err) {
      console.error(err);
      setError('Login request failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <section className="auth bg-base d-flex flex-wrap">
      <div className="auth-left d-lg-block d-none">
        <div className="d-flex align-items-center flex-column h-100 justify-content-center">
          <img src="/images/auth/auth-img.png" alt="" />
        </div>
      </div>
      <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
        <div className="max-w-464-px mx-auto w-100">
          <div>
            <Link to="/" className="mb-40 max-w-290-px d-block">
              <img src="/images/logo.png" alt="Logo" />
            </Link>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="position-relative mb-20">
              <label className="d-block mb-2 text-lg">Username</label>
              <div className="icon-field">
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="mage:email" />
                </span>
                <input
                  className='form-control h-56-px bg-neutral-50 radius-12'
                  name="username"
                  placeholder="Mobile or Email"
                  value={form.username}
                  onChange={e => setForm({ ...form, username: e.target.value })}
                  required
                />
              </div>
            </div>

            <div className="position-relative mb-20">
              <label className="d-block mb-2 text-lg">Password</label>
              <div className="icon-field">
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="solar:lock-password-outline" />
                </span>
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="form-control h-56-px bg-neutral-50 radius-12"
                  id="your-password"
                  placeholder="Password"
                  value={form.password}
                  onChange={e => setForm({ ...form, password: e.target.value })}
                  required
                />
              </div>
              <span
                className={`toggle-password ri-eye-line cursor-pointer position-absolute end-0 top-50 me-16 text-secondary-light ${showPassword ? 'ri-eye-off-line' : ''}`}
                onClick={togglePassword}
              ></span>
            </div>

            <div className="position-relative mb-20">
              <label className="d-block mb-2 text-lg">Academic Year</label>
              <div className="icon-field">
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="solar:calendar-outline" />
                </span>
                <select
                  className='form-control h-56-px bg-neutral-50 radius-12 pt-3'
                  name="academic_year"
                  value={form.academic_year}
                  onChange={e => setForm({ ...form, academic_year: e.target.value })}
                  required
                >
                  <option value="">Select Academic Year</option>
                  {years.map(y => (
                    <option key={y.id} value={y.id}>{y.year}</option>
                  ))}
                </select>
              </div>
            </div>
            
            <div className="position-relative mb-20">
              <label className="d-block mb-2 text-lg">Login As</label>
              <div className="d-flex gap-4 align-items-center">
                <label className="d-flex align-items-center gap-2">
                  <input
                    className='form-check-input'
                    type="radio"
                    name="loginas"
                    value="Student"
                    checked={form.loginas === 'Student'}
                    onChange={e => setForm({ ...form, loginas: e.target.value })}
                  />
                  Student
                </label>
                <label className="d-flex align-items-center gap-2">
                  <input
                    className='form-check-input'
                    type="radio"
                    name="loginas"
                    value="Teacher"
                    checked={form.loginas === 'Teacher'}
                    onChange={e => setForm({ ...form, loginas: e.target.value })}
                  />
                  Teacher
                </label>
              </div>
            </div>
            {/* <div className="position-relative mb-20">
              <div className="icon-field">
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="solar:lock-password-outline" />
                </span>
                <select
                  className='form-control h-56-px bg-neutral-50 radius-12 pt-3'
                  name="loginas"
                  value={form.loginas}
                  onChange={e => setForm({ ...form, loginas: e.target.value })}
                  required
                >
                  <option>Student</option>
                  <option>Teacher</option>
                </select>
              </div>
            </div> */}

            {/* Student Selector (dropdown inside form) */}
            {studentOptions && (
              <div className="position-relative mb-20">
                <label className="d-block mb-2 text-lg">Select Student</label>
                <div className="icon-field">
                  <span className="icon top-50 translate-middle-y">
                    <Icon icon="flowbite:users-group-outline" />
                  </span>
                  <select
                    className='form-control h-56-px bg-neutral-50 radius-12 pt-3'
                    name="regi_id"
                    value={form.regi_id}
                    onChange={e => setForm({ ...form, regi_id: e.target.value })}
                    required
                  >
                    <option value="">Select Student</option>
                    {studentOptions.map(o => (
                      <option key={o.regi_id} value={o.regi_id}>
                        {o.class_name} — {o.regi_id}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            <div className='col-12'>
              <div className="input-group">
                <button className="btn btn-primary text-lg btn-sm px-12 py-16 w-100 radius-12 mt-32" type="submit" disabled={loading || (studentOptions && !form.regi_id)}>
                  {loading ? 'Logging in...' : studentOptions ? 'Continue' : 'Login'}
                </button>
              </div>
            </div>
            
          </form>

          {message && <div style={{ color: 'green', marginTop: '10px' }}>{message}</div>}
          {error && <div style={{ color: 'red', marginTop: '10px' }}>{error}</div>}

        </div>
      </div>
    </section>
    </>
  );
}